import * as React from 'react';
import * as selectors from '../../../selectors/selectors';
import { ClusterComponent } from './ClusterComponent';
import { VeglenkeComponent } from './VeglenkeComponent';
import { VegobjektComponent } from './VegobjektComponent';
import { ConfigAndDataContext } from '@/state/context/ConfigAndDataContext';
import { VeglenkerComponent } from './VeglenkerComponent';
import { NodeComponent } from './NodeComponent';
import { resolveColor } from '@/utils/ColorHelper';
import { useSelector } from '@/state/store';

const ValgtContainer = () => {
    const { data } = React.useContext(ConfigAndDataContext);
    const selection = useSelector(selectors.stateValgt);
    const user = useSelector(selectors.stateUser);
    const vegobjekttyperInSearch = useSelector(selectors.stateSelectedRoadObjectTypes);
    const selectedVegnettlenke = selection?.singleVegnettlenke();

    if (!selection) return null;

    const colorMap = vegobjekttyperInSearch.reduce(
        (map, vegobjekttypestate) => {
            if (vegobjekttypestate.typeId === null || vegobjekttypestate.color === null) {
                return map;
            }

            return {
                ...map,
                [vegobjekttypestate.typeId]: resolveColor(vegobjekttypestate.color),
            };
        },
        {} as Record<number, string>
    );

    return (
        <>
            {selection.vegobjekter.map(vegobjekt => (
                <VegobjektComponent
                    key={vegobjekt.id}
                    user={user}
                    color={selection.color}
                    vegobjekt={vegobjekt}
                    vegobjekttyperInSearch={vegobjekttyperInSearch}
                    datakatalog={data.datakatalog}
                />
            ))}
            {selection.isSingle() && selectedVegnettlenke && (
                <VeglenkeComponent
                    color={selection.color}
                    vegnettlenke={selectedVegnettlenke}
                    datakatalog={data.datakatalog}
                />
            )}
            {selection.isCluster() && (
                <ClusterComponent colors={colorMap} selectedFeatures={selection} />
            )}
            {selection.nodes.map(node => (
                <div
                    key={node.id}
                    className="c-valgt"
                    tabIndex={-1}
                    aria-live="assertive"
                    aria-atomic="true"
                >
                    <NodeComponent node={node} />
                </div>
            ))}
            {Object.entries(selection.linkQueries).map(([query, links], index) => (
                <div
                    key={query}
                    className="c-valgt"
                    tabIndex={-1}
                    aria-live="assertive"
                    aria-atomic="true"
                >
                    <VeglenkerComponent
                        links={links}
                        queryString={query}
                        colorIndex={index}
                    />
                </div>
            ))}
        </>
    );
};

export default ValgtContainer;
